import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/order_history/
export const orderHistory = async () => {
  const response = await new Request().get('/ajax/order_history/')
  return Util.Obj.keysToCamel(response.data.orders)
}
